import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { DeliveryAgent, DeliveryAgentCreate, DeliveryAgentFilter } from '../data/deliveryAgent';

export function createDeliveryAgentService(client: AxiosInstance) {
  return createCrudService<DeliveryAgent, DeliveryAgentCreate, DeliveryAgentFilter>(
    client,
    '/restaurant/DeliveryAgent',
    'id',
  );
}

export type DeliveryAgentService = CrudService<DeliveryAgent, DeliveryAgentCreate, DeliveryAgentFilter>;
